module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/appModalView.html -->\n<div class="modal-dialog modal-md">\n	<div class="modal-content">\n		<div class="modal-header">\n			<div data-nx-control="crumbs"></div>\n			<div class="actions">\n				<button class="mdc-icon-button close" data-nx-control="close">\n					<span class="mdc-icon-button__icon">'+
((__t=( icons.faTimes ))==null?'':__t)+
'</span>\n				</button>\n			</div>\n		</div>\n		<div class="modal-body">\n			<div data-nx-control="modal-content"></div>\n		</div>\n	</div>\n</div>\n';
}
return __p;
};
